import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import GroupedAppointmentTypeList from './GroupedAppointmentTypeList/GroupedAppointmentTypeList.js';
import SingleAppointmentTypeList from './SingleAppointmentTypeList/SingleAppointmentTypeList.js';

const AppointmentTypeList = (_param)=>{
    var { className , appointmentDisplayType , appointmentTypes , groupedAppointmentTypes , appointmentTypeIcons , appointmentTypeToolTips , appointmentGlobalLabels , groupedAppointmentTypeToolTips , groupedAppointmentGlobalLabels , onClick , onClickToolTip  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "appointmentDisplayType",
        "appointmentTypes",
        "groupedAppointmentTypes",
        "appointmentTypeIcons",
        "appointmentTypeToolTips",
        "appointmentGlobalLabels",
        "groupedAppointmentTypeToolTips",
        "groupedAppointmentGlobalLabels",
        "onClick",
        "onClickToolTip"
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, appointmentDisplayType === 'single' && /*#__PURE__*/ React.createElement(SingleAppointmentTypeList, swcHelpers.extends({}, rest, {
        appointmentTypes: appointmentTypes,
        appointmentTypeIcons: appointmentTypeIcons,
        appointmentTypeToolTips: appointmentTypeToolTips,
        appointmentGlobalLabels: appointmentGlobalLabels,
        onClick: onClick,
        onClickToolTip: onClickToolTip,
        className: className
    })), appointmentDisplayType === 'group' && /*#__PURE__*/ React.createElement(GroupedAppointmentTypeList, {
        groupedAppointmentTypes: groupedAppointmentTypes,
        groupedAppointmentTypeToolTips: groupedAppointmentTypeToolTips,
        groupedAppointmentGlobalLabels: groupedAppointmentGlobalLabels,
        onClick: onClick,
        onClickToolTip: onClickToolTip,
        className: className
    }));
};

export { AppointmentTypeList as default };
//# sourceMappingURL=AppointmentTypeList.js.map
